import type { TablePaginationConfig } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";

export const useStandardPagination = (
  totalItems: number,
  initialPageSize = 20,
  resetKey?: unknown,
): TablePaginationConfig => {
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);

  useEffect(() => {
    if (totalItems >= 0) {
      setCurrent(1);
    }
  }, [totalItems]);

  const prevResetKey = useRef(resetKey);
  useEffect(() => {
    if (prevResetKey.current === resetKey) return;
    prevResetKey.current = resetKey;
    setCurrent(1);
  }, [resetKey]);

  const pagination = useMemo<TablePaginationConfig>(
    () => ({
      current,
      pageSize,
      total: totalItems,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
      onChange: (page, size) => {
        setCurrent(page);
        if (size && size !== pageSize) {
          setPageSize(size);
        }
      },
      showTotal: (total, range) => `${range[0]}-${range[1]} из ${total}`,
    }),
    [current, pageSize, totalItems],
  );

  return pagination;
};
